
export type NodeTypes = 'imageNode' | 'questionNode' | 'optionNode' | 'emailNode' | 'promptNode' | 'captureResponseNode' | 'searchNodesNode' | 'textInputNode' | "ticketNode" | "functionNode";

export const imageNode = {
    label: 'Image Upload',
    type: 'imageNode',
    inputColor: 'green',
    outputColor: 'green',
    singletons: [
        'questionNode',
        'imageNode',
        'answerNode',
        'promptNode'
    ]
}

export const functionNode = {
    label: 'Function',
    type: 'functionNode',
    inputColor: 'green',
    outputColor: 'green',
    singletons: [
        'questionNode',
        'imageNode',
        'answerNode',
        'promptNode'
    ]
}


export const captureResponseNode = {
    label: "Capture Response",
    type: "captureResponseNode",
    inputColor: 'yellow',
    outputColor: 'blue',
    singletons: [
        'questionNode',
        'imageNode',
        'answerNode',
        'promptNode'
    ]
}


export const sendEmailNode = {
    label: "Send Email",
    type: "emailNode",
    inputColor: 'yellow',
    outputColor: 'blue',
    singletons: [
        'questionNode',
        'imageNode',
        'answerNode',
        'promptNode'
    ]
}

export const questionNode = {
    label: "Question",
    type: "questionNode",
    inputColor: 'yellow',
    outputColor: 'blue',
    singletons: [
        'questionNode',
        'imageNode',
        /*'answerNode',*/
        'promptNode'
    ]
}

export const outputNode = {
    label: "Next",
    type: "promptNode",
    inputColor: '#C64b8C',
    outputColor: '#C64b8C',

}

export const promptNode = {
    label: "Text Prompt",
    type: "promptNode",
    inputColor: '#C64b8C',
    outputColor: '#C64b8C',
    singletons: [
        'questionNode',
        'imageNode',
        'answerNode',
        'promptNode'
    ]
}

export const ticketNode = {
    label: "Create Ticket",
    type: "ticketNode",
    inputColor: '#C64b8C',
    outputColor: '#C64b8C',
    singletons: [
        'questionNode',
        'imageNode',
        'answerNode',
        'promptNode'
    ]
}

export const optionNode = {
    label: '',
    type: 'optionNode',
    inputColor: 'blue',
    outputColor: 'yellow',
    singletons: [
        'questionNode',
        'imageNode',
        'answerNode',
        'promptNode'
    ]
};

export const emailNode = {
    label: "Send Email",
    type: "emailNode",
    inputColor: 'orange',
    outputColor: 'purple',
    isAction: true,
    singletons: [
        'questionNode',
        'imageNode',
        'answerNode',
        'promptNode'
    ]
}

export const yesNoNode = {
    label: "Yes or No",
    type: "yesNoNode",
    inputColor: 'orange',
    outputColor: 'green'
}

export const yesNode = {
    label: "Yes",
    type: "yesNode",
    inputColor: 'green',
    outputColor: 'green'
}

export const noNode = {
    label: "No",
    type: "noNode",
    inputColor: 'green',
    outputColor: 'green'
}

export const branchNode = {
    label: "No",
    type: "noNode",
    inputColor: 'green',
    outputColor: 'green'
}

